import React from 'react';
import { BaasicInput, Loader, BaasicHeader, BaasicButton, BaasicDropdown, BaasicCheckbox } from 'core/components';
import { translate, isSellerOrganization } from 'core/utils';
import { defaultTemplate } from 'core/hoc';
import { AmazonInventoryMergeTooltip } from 'common/tooltips';
import _ from 'lodash';

const SellerEditTemplate = ({ sellerEditViewStore, t }) => {
	const {
		form,
		loading,
		rootStore,
		isUpdateAction,
		isHavingAPIKey,
		generateApiKey,
		openEditSeller3PLCredentialsModal,
		openEditSellerWarehousesModal,
		countryDropdownStore,
		defaultLtlCarrierDropdownStore,
		stateDropdownStore,
		timezoneDropdownStore
	} = sellerEditViewStore;
	if (loading) return <Loader />;
	return (
		<section>
			<BaasicHeader title="SELLERVIEW.TITLE" rootStore={rootStore}>
				{isUpdateAction && (
					<BaasicButton
						className="btn btn--med btn--primary btn--primary--negative spc--right--tny"
						icon="icon icon--xmed icon--warehouse-change--white spc--right--sml"
						onClick={() => {
							openEditSellerWarehousesModal();
						}}
						label="SELLERWAREHOUSE.TITLE"
					/>
				)}
				<BaasicButton
					className="btn btn--med btn--primary btn--primary--negative"
					icon="icon icon--xmed icon--list-edit--white spc--right--sml"
					onClick={() => {
						openEditSeller3PLCredentialsModal();
					}}
					label="SELLER3PLCREDENTIALS.EDIT"
					authorization={store => !isSellerOrganization(store)}
				/>
			</BaasicHeader>
			<form className="container container--med container--footer" onSubmit={form.onSubmit}>
				<div className="container__group__wrapper">
					<div className="spc--bottom--sml">
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('applicationTitle')} />
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('identifier')} />
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('minimumInventory')} />
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('defaultSafeQuantity')} />
							</div>
						</div>
						{ isUpdateAction && (
							<div className="row">
								<div className="col col-sml-12 col-med-6">
									<BaasicDropdown dropdownStore={defaultLtlCarrierDropdownStore} isClearable={true} />
								</div>
							</div>
						)}
						{ isUpdateAction && (
							<div className="row">
								<div className="col col-sml-12 col-med-6 spc--top--sml">
									<BaasicCheckbox field={form.$('priceLtl')} />
								</div>
							</div>
						)}
						{ isUpdateAction && (
							<div className="row">
								<div className="col col-sml-12 col-med-6 spc--top--sml">
									<BaasicCheckbox field={form.$('useAmazonInventoryMerge')} />
									<AmazonInventoryMergeTooltip id="amazonInventoryMergeSellerTooltip" isSellerLevel={true} />
								</div>
							</div>
						)}
						{ isUpdateAction && (
							<div className="row">
								<div className="col col-sml-12 col-med-6 spc--top--sml">
									<BaasicCheckbox field={form.$('useSameCarrierPerOrder')} />
								</div>
							</div>
						)}
					</div>

					<h2 className="spc--bottom--sml">{t('WAREHOUSEVIEW.ADDRESS')}</h2>
					<div className="row spc--bottom--med">
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.address1')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.address2')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.address3')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.city')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicInput field={form.$('address.zipCode')} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicDropdown dropdownStore={countryDropdownStore} isClearable={true} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicDropdown dropdownStore={stateDropdownStore} isClearable={true} />
						</div>
						<div className="col col-sml-12 col-med-6">
							<BaasicDropdown dropdownStore={timezoneDropdownStore} isClearable={true} />
						</div>
					</div>

					<div className="spc--bottom--sml">
						<h2 className="spc--bottom--sml">{t('WAREHOUSEVIEW.CONTACT')}</h2>
						<div className="row">
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('contact.email1')} />
							</div>
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('contact.phone1')} />
							</div>
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('contact.email2')} />
							</div>
							<div className="col col-sml-12 col-med-6">
								<BaasicInput field={form.$('contact.phone2')} />
							</div>
							{!isUpdateAction && (
								<React.Fragment>
									<div className="col col-sml-12">
										<div className="separator--primary spc--top--sml spc--bottom--sml"></div>
									</div>
									<div className="col col-sml-12">
										<BaasicInput field={form.$('email')} />
									</div>
									<div className="col col-sml-6">
										<BaasicInput field={form.$('password')} />
									</div>
									<div className="col col-sml-6">
										<BaasicInput field={form.$('confirmPassword')} />
									</div>
								</React.Fragment>
							)}
						</div>
					</div>
					<div className="spc--bottom--med">
						<h2 className="spc--bottom--sml">{t('WAREHOUSEVIEW.APISECTION')}</h2>

						<div className="inputgroup">
							<div className="inputgroup--main">
								<BaasicInput field={form.$('apiKey')} disabled />
							</div>
							{!isHavingAPIKey ? (
								<div className="inputgroup--aside align--v--bottom">
									<button
										className="btn btn--med btn--secondary spc--bottom--sml spc--left--xsml"
										type="button"
										onClick={generateApiKey}
									>
										{t('GENERATEAPIKEY')}
									</button>
								</div>
							) : null}
						</div>
					</div>
				</div>
				{form.error && (
					<div>
						<p className="type--color--warning">{translate(form.error)}</p>
					</div>
				)}
				<button className="btn btn--med btn--primary" type="submit" disabled={loading}>
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{t('SAVE')}
				</button>
			</form>
		</section>
	);
};

export default defaultTemplate(SellerEditTemplate);
